import { render, staticRenderFns } from "./DescriptionEditor.vue?vue&type=template&id=57436554&"
import script from "./DescriptionEditor.vue?vue&type=script&lang=ts&"
export * from "./DescriptionEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports